import "animated-scroll-to";

export const backToTop = function (el) {
    animateScrollTo(0, {
        easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
        minDuration: 1000,
        maxDuration: 2000,
        speed: 1000,
    });
};
